export default __webpack_public_path__ + "static/media/14.d6486aa4.jpg";